var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9da85da370f3ec4862f78cd6e45fd9bae72a2c42"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["ticker-sentry@ticker"]={id:"9da85da370f3ec4862f78cd6e45fd9bae72a2c42"};
      